import { combineReducers } from 'redux';

import topics from './topics';
import posts from './posts';
import partners from './partners';
import experts from './experts';
import links from './links';
import social_links from './social_links';
import followings from './followings';
import linked_events from './linked_events';
import categories from './categories';
import members from './members';

export default combineReducers({
  topics,
  followings,
  linked_events,
  categories,
  experts,
  partners,
  links,
  social_links,
  posts,
  members,
});
